module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    staticClass: "Office"
  }, [_c('md-whiteframe', {
    staticClass: "shadow shadow-faint"
  }, [_c('div', {
    staticClass: "search search--field"
  }, [_c('h3', {
    staticClass: "dialog--title"
  }, [_vm._v("Historial de Modificiones")]), _vm._v(" "), _c('span', [_c('md-button', {
    staticClass: "md-icon-button md-raised button-remove",
    attrs: {
      "data-step": "1",
      "data-intro": "Presiona el Boton para Solicitar un Box"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closedView()
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "table table--office table-mobile has-status table--queries"
  }, [_c('md-table-card', {
    staticClass: "table--wrap"
  }, [(_vm.disabledRegion) ? _c('div', [_c('div', {
    staticClass: "sk-rotating-plane"
  })]) : _c('div', [_c('md-table', {
    attrs: {
      "md-sort": "name"
    },
    on: {
      "sort": _vm.onSort,
      "select": _vm.onSelect
    }
  }, [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', {
    staticClass: "td-sort-name center-mobile",
    attrs: {
      "md-sort-by": "yt"
    }
  }, [_vm._v("Especialidad")]), _vm._v(" "), _c('md-table-head', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Precio")]), _vm._v(" "), _c('md-table-head', {
    staticClass: "text-center hidden-mobile",
    attrs: {
      "md-sort-by": "active"
    }
  }, [_vm._v("Estus de la Solicitud")]), _vm._v(" "), _c('md-table-head', {
    staticClass: "text-center hidden-mobile"
  }, [_vm._v(_vm._s(_vm.translate.pages.office.index.fields.actions))])], 1)], 1), _vm._v(" "), (_vm.offices.length > 0) ? _c('md-table-body', _vm._l((_vm.offices), function(row, rowIndex) {
    return _c('md-table-row', {
      key: rowIndex,
      attrs: {
        "md-item": row
      }
    }, [_c('md-table-cell', {
      staticClass: "name--cell"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(row.speciality.name))]), _vm._v(" "), _c('span', {
      staticClass: "subname visible-mobile"
    }, [_vm._v("\n                                    " + _vm._s(row.region.toponymName) + ", " + _vm._s(row.city.toponymName) + "\n                                ")]), _vm._v(" "), _c('span', {
      staticClass: "subname visible-mobile"
    }, [_c('strong', [_vm._v("\n                                        $" + _vm._s(row.price) + "\n                                    ")])])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "hidden-small"
    }, [_c('span', [_c('strong', [_vm._v("\n                                        $" + _vm._s(row.price) + "\n                                    ")])])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "static-mobile"
    }, [_c('div', {
      class: "enabled " + row.status
    }, [(row.status == 'on_review') ? _c('span', [_vm._v("En revisión")]) : _vm._e(), _vm._v(" "), (row.status == 'approved') ? _c('span', [_vm._v("Aprobada")]) : _vm._e(), _vm._v(" "), (row.status == 'denied') ? _c('span', [_vm._v("Denegado")]) : _vm._e()])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "actions"
    }, [_c('span', [_c('md-icon', {
      staticClass: "icon-view raised",
      attrs: {
        "data-step": "2",
        "data-intro": "Presiona el Boton  Editar"
      },
      nativeOn: {
        "click": function($event) {
          _vm.openView('view', row, rowIndex)
        }
      }
    }, [_vm._v("\n                                        remove_red_eye\n                                    ")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Ver")])], 1)])], 1)
  })) : _vm._e()], 1)], 1)]), _vm._v(" "), (_vm.offices.length === 0) ? _c('div', [(_vm.search.isQuery) ? _c('h3', {
    staticClass: "not-found mini-found"
  }, [_vm._v(_vm._s(_vm.translate.pages.office.index.no_name_result) + " \""), _c('strong', [_vm._v(_vm._s(_vm.search.query) + "\".")])]) : _c('h3', [(_vm.fetchData) ? _c('span', {
    staticClass: "not-found mini-found"
  }, [_vm._v("Aún no ha realizado modificaciones en su Solicitudes de BOX.")]) : _c('span', [_c('div', {
    staticClass: "sk-rotating-plane"
  })])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px",
      "display": "block",
      "width": "100%"
    }
  }), _vm._v(" "), _c('md-dialog', {
    ref: "view",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-content', [_c('add-box', {
    attrs: {
      "boxData": _vm.boxObj,
      "infoData": _vm.infoObj
    },
    on: {
      "closed": _vm.closed
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-230a5b17"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/BoxesSolicitud/history.vue
// module id = 678
// module chunks = 1